export default "<p>socket works!</p>\n";